// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__35Ay1","content":"styles_content__2Bffh","checkbox":"styles_checkbox__3XrGD","checkboxLabel":"styles_checkboxLabel__2ILAJ"};